module.exports = __webpack_public_path__ + "static/media/galerija_2022_0027.d11163ac.jpg";